<template>
  <div class="orderDetailContent" v-if="isLogined">
    <div class="deliveryInfo">
      <div class="title">收货信息</div>
      <div class="deliveryContent">   
          <div class="deliveryAddress">
            <div class="addressInfo">
              <div>
                <div class="labelName">收 货 人：</div><div class="labelValue">{{memberDetial.nickName}}</div>
              </div> 
              <div>
                <div class="labelName">联系方式：</div><div class="labelValue">{{desensitize(memberDetial.mobile)}}</div>
              </div>
              <div>
                <div class="labelName">所在地区：</div><div class="labelValue">{{ memberDetial.province }} {{ memberDetial.city }} {{ memberDetial.area }}</div>        
              </div>
              <div>
                <div class="labelName">详细地址：</div><div class="labelValue">{{ memberDetial.address }} </div>
              </div>
              <div v-if="orderStatus==1">
                 <input type="button" value="切换地址" @click="changeAddress">
              </div>
            </div>
            <div class="operate">    
              <div>         
                <div class="orderLabelName">订单编号：{{orderInfo.orderCode}}</div>
              </div>
              <div>         
                <div class="orderLabelName">订单状态：{{orderInfo.status}}</div>
              </div>             
              <div v-if="orderStatus == 3 || orderStatus == 4">
                <div class="labelName">物流公司：</div><div class="labelValue">{{ orderInfo.logisticsCompany }} </div>
              </div>
              <div v-if="orderStatus == 3 || orderStatus == 4">
                <div class="labelName">物流单号：</div><div class="labelValue">{{ orderInfo.logisticsNo }} </div>
              </div>
              <div v-if="orderStatus==1" >
                <div class="operateLabelName">您可以<input type="button" class="operateBtn" value="立即付款" @click="orderPayment(orderId)"> <input type="button" class="operateBtn1" @click="_cancelOrder()" value="取消订单"></div>
              </div>
              <div v-if="orderStatus==3">
                <div class="operateLabelName">您可以<input type="button" class="operateBtn" value="确认收货" @click="orderConfirm(orderId)"></div>
              </div>
              <div v-if="(orderStatus==2||orderStatus==3||orderStatus==4)&&orderInfo.invoiceStatus=='未开票'">
                <div class="operateLabelName">您可以<input type="button" class="operateBtn" value="申请发票" @click="applyInvoice(orderId)"></div>
              </div>
              <div v-if="orderInfo.invoiceStatus !='未开票'">
                <div class="labelName">开票状态：</div><div class="labelValue">{{ orderInfo.invoiceStatus }} <a class="downloadBtn" v-if="orderInfo.invoiceAnnex" :href="orderInfo.invoiceAnnex" target="_blank">发票下载</a> </div>
              </div>
            </div>
          </div>         
        </div>    
    </div>
    <div class="productInfo">
      <div class="title">商品信息</div>   
      <table>
        <tr class="productHead">
            <th class="productInfo" colspan="2" >商品信息</th>
            <th class="productPrice">单价</th>
            <th class="productNum">数量</th>
            <th class="productTotal">总价</th>
          </tr>
          <tr v-for="(item,i) in orderList" :key="'product_'+i">
            <td class="productImage"><img @click="goodsDetails(item.productId)" :src="item.defaultImage"></td>
            <td class="productName">{{item.name}}({{item.specName}})</td>
            <td>￥{{Number(item.price).toFixed(2)}}</td>
            <td>{{item.num}}</td>
            <td>￥{{Number(item.price*item.num).toFixed(2)}}</td>
          </tr>
      </table>  
      <div class="orderfooter"> 
        <div class="productTotal">商品总价：<div>￥{{productTotal.toFixed(2)}}</div></div>
        <div class="postFee">运费(快递)：<div>￥{{postFee.toFixed(2)}}</div></div>
        <div class="orderAmount">订单总价：<div>￥{{orderTotal.toFixed(2)}}</div></div>
        <div class="payAmount">实付款：<div>￥{{orderTotal.toFixed(2)}}</div></div>
      </div>
    </div>
    <selectAddress ref="selectAddress" @fetch-data="_getOrderDet"></selectAddress>
    <applyInvoice ref="applyInvoice" @fetch-data="_getOrderDet"></applyInvoice>
  </div>
  <div class="orderDetailContent1" v-else >
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/orderDetail.css';
</style>
<script>
  import api from '@/api'
  import { getOrder,finish, cancelOrder } from '@/api/order'
  import { getStore, setStore} from '@/utils/storage'
  import SelectAddress from './components/SelectAddress' 
  import ApplyInvoice from './components/ApplyInvoice'
  import util  from '@/utils/util'
  import { mapState} from 'vuex'
  export default {
    data () {
      return {
        orderInfo:{},
        orderList: [0],
        orderTotal:0.00,      
        postFee:0.00,
        productTotal:0.00,
        orderStatus: 0,
        orderId: '',
        memberDetial:{},
        orderTitle: '',
        loading: true,
        countTime: 0
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: {
      changeAddress()
      {     
        this.$refs['selectAddress'].showSelect(this.orderInfo)  
      },      
      desensitize(mobile)
      {
         var temp=mobile;
         if( temp!=undefined && temp.length==11)
         {
            var start = temp.substring(0, 3);
            var end = temp.substring(7,11);
            temp = start + '****'+end;
         }
         return temp;
      },
      message (m) {
        this.$message.error({ message: m })
      },
      applyInvoice(order)
      {
        this.$refs['applyInvoice'].show(order)
      },
      orderPayment (orderId) {
        let  addressInfo = {
          address:this.memberDetial.address,
          mobile:this.memberDetial.mobile,
          name:this.memberDetial.nickName
        }
        setStore('addressInfo',addressInfo)
        let cartList = []
      
        this.orderList.forEach(e => {
          cartList.push({
            productId:e.id,
            specId:e.specId,
            settlementPrice:e.price,
            name:e.pName,
            specName:e.specName,
            num:e.num,
            defaultImage:e.defaultImage
          })
        });
        setStore('cartlist',cartList)
        window.open(window.location.origin + '#/order/payment?orderId=' + orderId)
      },
      goodsDetails (id) {
        window.open(window.location.origin + '#/goodsDetails?productId=' + id)
      },
     
      _getOrderDet () {
       
        getOrder({id:this.orderId}).then(res => {
          if (res.data.success === true) {            
          this.orderInfo = res.data.result
          
          this.orderInfo.creationTime = util.getDate(this.orderInfo.creationTime)
          this.orderInfo.payTime = util.getDate(this.orderInfo.payTime)
          if (this.orderInfo.isCancel) {
            this.orderStatus = -1
          } else if (!this.orderInfo.isPay && !this.orderInfo.isCancel) {
            this.orderStatus = 1 //待付款
          } else if (this.orderInfo.isPay && !this.orderInfo.isDelivery && !this.orderInfo.isRefund) {
            this.orderStatus = 2 //已支付
          }else if (this.orderInfo.isPay && this.orderInfo.isDelivery && !this.orderInfo.isRefund && !this.orderInfo.isFinish) {
            this.orderStatus = 3 //已发货
          } else if (this.orderInfo.isFinish && !this.orderInfo.isRefund) {
            this.orderStatus = 4 //订单完成
          } 
          console.log(this.orderStatus)
            this.orderList = res.data.result.orderDetial
            this.productTotal=0.00;
            for(var i=0;i<this.orderList.length;i++)
            {
              this.productTotal += this.orderList[i].price*this.orderList[i].num;
            }
            this.orderTotal = res.data.result.realAmount
            this.postFee = res.data.result.postFee;
            this.memberDetial = res.data.result.memberDetial
            this.orderTitle = '订单号：' +  this.orderInfo.orderCode
            this.loading = false
          }
        })
      },
      _cancelOrder () {
        this.$confirm('确定取消该订单吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((r) => {
        cancelOrder({id:this.orderInfo.id}).then(res => {
          if (res.data.success === true) {
            this.$message({ message: '取消成功', type: 'success', customClass: 'c-msg' })
            this._getOrderDet();
          }else{
            this.message(res.data.error.message)
          } 
         })
        })
      },
      orderConfirm(id){     
      finish({id:id}).then(res => {
          if (res.data.success === true) {
            this._getOrderDet()
          }else{
            this.message(res.data.error.message)
          } 
        })
      },

    },
    
    created () {
      if(this.isLogined)
      {
        this.orderId = this.$route.query.orderId
        this._getOrderDet()
      }
    },
    components: {    
      SelectAddress,
      ApplyInvoice
    }
  }
</script>



// WEBPACK FOOTER //
// OrderDetail.vue?1ff9f84e